function parse(townName, filename, season = 'fall') {
    const townChunkNum = townName
        .split(',')[0]
        .trim()
        .split(' ').length;

    filename = filename.split('.')[0];

    let chunks = filename
        .replace(/ /g, '_')
        .replace(/_+/g, '_')
        .replace('_2018-fall', '')
        .replace('_2019-spring', '')
        .split('_');
    let grade = chunks.pop().trim();
    let roundChunk = chunks
        .pop()
        .trim()
        .toLowerCase();
    let levelChunk = chunks
        .pop()
        .trim()
        .toLowerCase();
    let hasRound = [
        'б', // Базовый
        'o', // O-level
        'с', // Сложный
        'a', // A-level
    ].includes(roundChunk);
    let hasLevel = [
        'м', // Младший
        'j', // Junior
        'с', // Старший
        's', // Senior
    ].includes(levelChunk);

    let round = ['б', 'o'].includes(roundChunk) ? (season === 'fall' ? 'p' : 't') : season === 'fall' ? 'm' : 'v';
    let level = ['м', 'j'].includes(levelChunk) ? 'junior' : 'senior';

    chunks.splice(0, townChunkNum);

    let name = chunks.join(' ').trim();

    return {
        name,
        grade,
        hasRound,
        round,
        hasLevel,
        level,
    };
}

export function parseFileName(townName, filename, season) {
    try {
        const { name, grade, round, level } = parse(townName, filename, season);

        return {
            name,
            grade,
            round,
            level,
        };
    } catch (e) {
        return {
            name: '',
            grade: '',
            round: '',
            level: '',
        };
    }
}

export function validateFilename(townName, filename, season) {
    try {
        const { name, grade, hasRound, hasLevel } = parse(townName, filename, season);

        return name && grade && hasRound && hasLevel;
    } catch (e) {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/utils/parseFileName.js